import { useState } from "react";
import { Menu } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";

const LINKS = [
  ["Servicios", "#servicios"],
  ["Herramientas IA", "#herramientas"],
  ["Paquetes", "#paquetes"],
  ["Preguntas", "#faq"],
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-[#E8E1D7] bg-[#FAF7F2]/90 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Logo />
        <nav className="hidden items-center gap-8 md:flex">
          {LINKS.map(([label, href]) => (
            <a key={href} href={href} data-testid={`nav-${href.slice(1)}`}
              className="text-sm font-medium text-[#6E655F] transition-colors hover:text-[#E05A47]">{label}</a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Button asChild data-testid="header-quote-button" className="hidden rounded-full bg-[#1E1A17] px-5 hover:bg-[#E05A47] sm:inline-flex">
            <a href="#contacto">Pedir cotización</a>
          </Button>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="md:hidden" data-testid="mobile-menu-button"><Menu /></Button>
            </SheetTrigger>
            <SheetContent className="bg-[#FAF7F2]">
              <SheetTitle className="sr-only">Menú</SheetTitle>
              <div className="mt-10 flex flex-col gap-6">
                {LINKS.map(([label, href]) => (
                  <a key={href} href={href} onClick={() => setOpen(false)} data-testid={`mobile-nav-${href.slice(1)}`}
                    className="font-display text-2xl">{label}</a>
                ))}
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
